
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import AddUser from "./AddUser";
import UserList from "./UserList";
import UserPermissions from "./UserPermissions";
import UserActivityLogs from "./UserActivityLogs";
import Navigationbar from "../Navigationbar";

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#2e3442",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

const UserAccounts = () => {
  const location = useLocation();
  const [activeSubTab, setActiveSubTab] = useState(0); // Default to first tab

  const subTabs = [
    { label: "Add User", content: <AddUser /> },
    { label: "User List", content: <UserList /> },
    // { label: "User Permissions", content: <UserPermissions /> },
    { label: "User Activity", content: <UserActivityLogs /> },
  ];

  // Set the subtab based on passed state from Link
  useEffect(() => {
    if (location.state?.activeSubTab) {
      const tabIndex = subTabs.findIndex(tab => tab.label === location.state.activeSubTab);
      if (tabIndex !== -1) setActiveSubTab(tabIndex);
    }
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box
        className="user-accounts-page"
        sx={{
          height: "100vh",
          overflow: "hidden",
          '@media (max-width: 768px)': {
            minWidth: 0,
            height: '100dvh',
            overflowX: 'hidden',
            overflowY: 'auto',
            '& *': {
              boxSizing: 'border-box',
            },
            '& .bordered-div': {
              width: '100%',
              maxWidth: '100%',
              margin: '12px 0 0 !important',
              padding: { xs: '14px', sm: '20px' },
            },
            '& .bordered-div .MuiAlert-root': {
              width: '100% !important',
              maxWidth: '100%',
              marginLeft: '0 !important',
            },
            '& .form-group': {
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: '6px',
            },
            '& .form-group > label': {
              width: '100%',
              marginRight: 0,
              textAlign: 'left',
            },
            '& .form-group > input, & .form-group > select, & .form-group > textarea, & .form-group > div': {
              width: '100% !important',
              maxWidth: '100%',
            },
            '& .form-group input:not([type="checkbox"]), & .form-group select, & .form-group textarea': {
              width: '100% !important',
              maxWidth: '100%',
            },
            '& .bordered-div > div:last-of-type': {
              marginLeft: '0 !important',
              width: '100% !important',
              height: 'auto !important',
            },
            '& .grid-container-user': {
              gridTemplateColumns: 'minmax(0, 1fr) !important',
              width: '100%',
            },
            '& .client-card': {
              minWidth: 0,
              width: '100%',
              maxWidth: '100%',
            },
            '& .search-container': {
              width: '100%',
              marginRight: 0,
            },
            '& #search-input': {
              width: '100%',
              maxWidth: '100%',
            },
            '& .Slide-device-Add-form': {
              width: '100%',
              maxWidth: '100%',
              height: '100%',
              padding: { xs: '12px', sm: '20px' },
              overflowY: 'auto',
              borderRadius: 0,
            },
            '& .form-group-device-edit': {
              flexDirection: 'column',
              alignItems: 'stretch',
            },
            '& .form-group-device-edit label, & .form-group-device-edit input, & .form-group-device-edit select': {
              width: '100% !important',
              maxWidth: '100%',
              marginRight: 0,
            },
            '& table': {
              minWidth: '640px',
            },
          },
        }}
      >
        {/* Navigation Bar */}
        <Navigationbar />
        <Box
          sx={{
            marginLeft: "8.5%",
            '@media (max-width: 768px)': {
              width: '100%',
              minWidth: 0,
              marginLeft: 0,
            },
          }}
        >
          {/* Subtabs */}
          <Box sx={{
            borderBottom: 1,
            borderColor: "divider",
            mt: 1,
            ml: 3,
            backgroundColor:'#2c2c2c',
            '@media (max-width: 768px)': {
              mt: 0,
              ml: 0,
              width: '100%',
              overflowX: 'auto',
              '& .MuiTabs-scroller': {
                overflowX: 'auto !important',
              },
              '& .MuiTabs-flexContainer': {
                minWidth: 'max-content',
              },
            },
          }}>
            <Tabs
              value={activeSubTab}
              onChange={(e, newValue) => setActiveSubTab(newValue)}
              textColor="white"
              indicatorColor="primary"
            >
              {subTabs.map((tab, index) => (
                <Tab key={index} label={tab.label} 
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#717b86",
                    fontWeight: 550,
                  },
                }}
                />
              ))}
            </Tabs>
          </Box>

          {/* Tab Content */}
          <Box sx={{
            p: 0.5,
            '@media (max-width: 768px)': {
              width: '100%',
              minWidth: 0,
              p: { xs: 1, sm: 1.5 },
              overflowX: 'auto',
            },
          }}>
            <Typography component="div">
              {subTabs[activeSubTab].content}
            </Typography>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default UserAccounts;
